export const ModifyVideoReviewReason = {
  name: "video-review-reason-modify",
  component: "MainPanel",
  layout: "main-panel x-large",
  mode: "visible",
  text: "reason",
  showOn: [{ state: "editState", value: "video-review-reason-modify", operator: "is" }],
  allowCancel: true,
  showDetails: { events: ["edit"] },
  children: [
    {
      name: "video-review-reason-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [true],
      options: {
        value: "singleOption",
        optionName: "reason",
        layout: "type-button",
        prefix: "reason",
        children: [
          "period_end",
          "clock_correction",
          "shot_clock_violation",
          "non_shooting_foul",
          "goaltending",
          "out_of_bounds",
          "field_goal_success",
          "free_throws_shooting_foul",
          "foul_change",
          "identify_ft_shooter",
          "violence",
        ],
      },
      actionGroups: [
        {
          actions: [
            { action: "sendEvent", value: "edit", type: "main" },
            { action: "nextState", value: null, type: "editState" },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
